import { ISearchBoxProps as FISearchBoxProps, ISearchBoxStyles, SearchBox as FSearchBox } from '@fluentui/react';
import { ChangeEvent, forwardRef, Ref } from 'react';

import { IComponent, IconName } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { searchBoxStylesDefault } from './SearchBox.styles';

export interface ISearchBoxProps extends Omit<FISearchBoxProps, 'styles'>, IComponent<ISearchBoxStyles> {
  onTextChange?: (searchText: string) => void;
}

export const SearchBox = forwardRef((props: ISearchBoxProps, ref: Ref<HTMLDivElement>) => {
  const { styles, onTextChange, ..._fProps } = props;
  const {
    onEscape,
    onClear,
    onChange,
    autoFocus = true,
    iconProps = { iconName: IconName.Zoom },
    placeholder = 'What do you want to search?',
  } = _fProps;
  const fProps: FISearchBoxProps = {
    ..._fProps,
    styles: useThemeStyles<ISearchBoxStyles>(searchBoxStylesDefault, styles),
    iconProps,
    placeholder,
    autoFocus,
    onEscape: onEscape ? onEscape : onTextChange ? () => onTextChange('') : undefined,
    onClear: onClear ? onClear : onTextChange ? () => onTextChange('') : undefined,
    onChange: onChange
      ? onChange
      : onTextChange
      ? (_e?: ChangeEvent<HTMLInputElement>, search_term = '') => onTextChange(search_term)
      : undefined,
  };
  return <FSearchBox {...fProps} ref={ref} data-test={props['data-test'] || 'search-box-input'} />;
});
